module.exports = __webpack_public_path__ + "img/on_rounded.35c3b434.svg";